import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { FlowConfig } from '@swf/core/types/Wizard';

import useRmfBRFlow from './useRmfBRFlow';
import useRmfCAONFlow from './useRmfCAONFlow';
import useRmfDefaultFlow from './useRmfDefaultFlow';
import useRmfESFlow from './useRmfESFlow';
import useRmfFRFlow from './useRmfFRFlow';
import useRmfITFlow from './useRmfITFlow';
import useRmfROFlow from './useRmfROFlow';
import useRmfUKFlow from './useRmfUKFlow';
import useRmfUSMIFlow from './useRmfUSMIFlow';
import useRmfUSPANJFlow from './useRmfUSPANJFlow';

const useRmfFlow = (): FlowConfig => {
  const CAONFlow = useRmfCAONFlow();
  const UKFlow = useRmfUKFlow();
  const FRFlow = useRmfFRFlow();
  const ITFlow = useRmfITFlow();
  const ROFlow = useRmfROFlow();
  const BRFlow = useRmfBRFlow();
  const ESFlow = useRmfESFlow();
  const USMIFlow = useRmfUSMIFlow();
  const USPANJFlow = useRmfUSPANJFlow();
  const defaultFlow = useRmfDefaultFlow();
  const siteId = useSelector(select.cms.getSiteId);
  const country = useSelector(select.country.getCountry);

  const flow = {
    [Sites.CA_ON]: CAONFlow,
    [Sites.FRA]: FRFlow,
    [Sites.ITA]: ITFlow,
    [Sites.ROM]: ROFlow,
    [Sites.UK]: UKFlow,
    [Sites.SPA]: ESFlow,
    [Country.Brazil]: BRFlow,
    [Sites.USMI]: USMIFlow,
    [Sites.US_NJ]: USPANJFlow,
    [Sites.US_PA]: USPANJFlow,
    default: defaultFlow
  };

  return flow[siteId] || flow[country] || flow.default;
};

export default useRmfFlow;
